import React from 'react';

export default function EditPencilSVG() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.87898 1.56092L7.17138 0.853329L1.70654 6.31623L1.28321 8.15474L3.12172 7.73142L8.58657 2.26851L7.87898 1.56092Z"
        stroke="#5E5E5E"
      />
    </svg>
  );
}
